import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'astroturf';
import copy from 'copy-text-to-clipboard';
import React, { useCallback, useMemo, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const Link = /*#__PURE__*/styled('span', null, {
  displayName: "Link",
  styles: require("./ImportApi-Link.module.scss"),
  attrs: null,
  vars: []
});

const Keyword = /*#__PURE__*/styled('span', null, {
  displayName: "Keyword",
  styles: require("./ImportApi-Keyword.module.scss"),
  attrs: null,
  vars: []
});

const Code = /*#__PURE__*/styled('code', null, {
  displayName: "Code",
  styles: require("./ImportApi-Code.module.scss"),
  attrs: null,
  vars: []
});

const COPY_IMPORT_TEXT = 'Copy import code';
const COPIED_IMPORT_TEXT = 'Copied!';

const CopyImport = ({ name }) => {
  const [text, setText] = useState(COPY_IMPORT_TEXT);
  const textToCopy = useMemo(
    () => `import ${name} from 'react-bootstrap/${name}'`,
    [name],
  );

  const handleCopy = useCallback(() => {
    copy(textToCopy);
    setText(COPIED_IMPORT_TEXT);
    setTimeout(() => setText(COPY_IMPORT_TEXT), 2000);
  }, [textToCopy]);

  return (
    <OverlayTrigger
      overlay={<Tooltip id={`copy-${name}-import-tooltip`}>{text}</Tooltip>}
    >
      <Link onClick={handleCopy} className="js-search-exclude">
        <FontAwesomeIcon icon={faCopy} />
        <span className="sr-only">{`Copy import code for the ${name} component`}</span>
      </Link>
    </OverlayTrigger>
  );
};

export default ({ name }) => (
  <>
    <Code aria-label={`Import code for the ${name} component`}>
      <Keyword>import</Keyword> {name} <Keyword>from</Keyword> 'react-bootstrap/
      {name}'
    </Code>
    <CopyImport name={name} />
  </>
);
